
<template>
    <div>
    <div class="i9_documents_block">
              <h4>Identify Document</h4>
              <div class="i9_documents_cnt">
                  <div class="i9_document_item">
                    <div class="i9_document_title mb-0">
                      <docType  :item="caseDetails.verifierDetails.identifyDoc[0]"/>
                      <span>{{checkProperty(caseDetails.verifierDetails.identifyDocType, 'name') }}<label v-if="checkProperty(caseDetails['verifierDetails']['identifyDoc'][0], 'uploadedOn')">Uploaded On: <strong>{{caseDetails['verifierDetails']['identifyDoc'][0]['uploadedOn'] | formatDateTime }}</strong></label></span>
                      <div class="actions">
                        <button class="actions_btn" @click="fetchSignedUrl(caseDetails.verifierDetails.identifyDoc[0], false, true)">View</button>
                        <button class="actions_btn" @click="downloads3file(caseDetails.verifierDetails.identifyDoc[0])">Download</button>
                      </div>
                    </div> 
                  </div> 
              </div>
            </div>
            <vs-popup
                    class="document_modal document_modal-v2 "
                    :class="{ 'expand': expandModal, 'custom_close_doc_modal':showCloseIcon }"
                    :title="checkProperty(selectedFile, 'name')"
                    :active.sync="docPrivew"
                    >
                    <div class="document_actions" @click="expandModal = !expandModal">
                    <figure v-if="!expandModal" class="maximize-img"><img src="@/assets/images/maximize.png"  width="18" height="18"/></figure>
                    <figure v-else class="minimize-img"><img src="@/assets/images/minimize.png"  width="20" height="20"/></figure>
                    </div>
                    <div class="custom_close" v-if="showCloseIcon">
                    <figure class="close_icon" @click="showConfrmLetterPopup = true;updateletterLoading = false;errorMessage=''">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 20"><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z"/></svg>
                    </figure>
                    </div>
                    <h2>
                        <img
                        :class="{
                            pdf_view_download: docType == 'pdf',
                            office_view_download: docType == 'office',
                            image_view_download: docType == 'image',
                        }"
                        class="download-button"
                        @click="downloads3file(selectedFile)"
                        src="@/assets/images/download.svg"
                        />
                    </h2>
                    <div class="pdf_loader">
                        <figure v-if="formSubmited && !saveEditedFile" class="loader loader2">
                        <img src="@/assets/images/main/loader.gif" />
                        </figure>

                        <!-- <span :class="{'pdf_view_close':docType == 'pdf', 'office_view_close':docType == 'office'  , 'image_view_close 33':docType =='image'}" class="close close2" @click="docPrivew= false"></span> -->
                        <template v-if="docType == 'office'">
                        <div style="height: 90vh">
                            <div id="placeholder" style="height: 100%"></div>
                        </div>
                        </template>
                        <template v-else-if="docType == 'image'">
                        <img :src="docValue" />
                        </template>
                        <template v-else-if="docType == 'pdf'">
                        <div class="pdf" style="height: 90vh">
                            <iframe
                            v-if="docValue != ''"
                            border="0"
                            style="border: 0px"
                            :src="docValue"
                            height="100%"
                            width="100%"
                            >
                            </iframe>
                        </div>
                        </template>
                    </div>
            </vs-popup>
            </div>
  </template>
  <script>
  import moment from 'moment'
  import Vue from 'vue';
  import docType from "@/views/common/docType.vue";
  
  export default {
    inject: ["parentValidator"],
    created() {
        this.$validator = this.parentValidator;
    },
    components: {
      docType,
    },
    methods: {
    formatDate(dateTime) {
      return new Date(dateTime).toLocaleString(); 
    },
    fetchSignedUrl(value,download = false, viewmode = false) {
      console.log("fetchSignedUrl",value)
      value.download = download;
      value.viewmode = viewmode;
      this.download_or_view(value);
    },
    download_or_view(docItem) {
      let value = _.cloneDeep(docItem);
      this.selectedFileForEdit =false;
      this.showCloseIcon = false;
      if ( _.has(value ,'viewmode') && this.checkProperty(value,'viewmode')==false ) {
      this.selectedFileForEdit =true;
      }

      this.expandModal= false;

      if (
      this.checkProperty(this.getPetitionDetails, "caseNo") &&
      this.checkProperty(value, "name")
      ) {
      let docName = _.cloneDeep(value["name"]);

      try{
      if(!docName.includes(this.checkProperty(this.getPetitionDetails, "caseNo"))){
        value["name"] = docName;
      }
      }catch(err){

      }


      }

      var _self = this;
      this.formSubmited = false;
      if (_.has(value, "path")) {
      value["url"] = value["path"];
      value["document"] = value["path"];
      }

      if (_.has(value, "url")) {
      value["path"] = value["url"];
      value["document"] = value["url"];
      }

      if (_.has(value, "document")) {
      value["path"] = value["document"];
      value["url"] = value["document"];
      }

      this.selectedFile = value;
      this.docValue = "";
      this.docPrivew = false;
      this.docType = false;
      this.docType = this.findmsDoctype(value);
      this.showCloseIcon = false;

      //if ( (this.docType == "office" || this.docType == "image" || this.docType == "pdf") && value.download == false ) {
      if (this.docType == "office" || this.docType == "image" || this.docType == "pdf") {
      value.url = value.url.replace(this.$globalgonfig._S3URL, "");
      value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
      let postdata = {
      keyName: value.url,
      petitionId: value["petitionId"],
      };
      this.$store.dispatch("getSignedUrl", postdata).then((response) => {
      this.docValue = response.data.result.data;

      if (this.docType == "office") {
        document.getElementById("placeholder").innerHTML =
          "  <div  id='placeholder2' style='height:100%'></div>";
        let _editing = false;

        if ([50, 51].indexOf(this.getUserRoleId) > -1) {
          _editing = false;
        }
        
        let docViewUrl ='https://immibox.com/api/petition/post-edited-document';
        if(_.has(this.$globalgonfig, 'DOC_VIEW_URL')){
          docViewUrl = this.$globalgonfig['DOC_VIEW_URL'];
        }

        let entityId = 'cover_letter';
        if(this.checkProperty(value,'entityId')){
          entityId = value['entityId'];
        }
            
        if ( _.has(value ,'viewmode') && value.viewmode==false ) {
          _editing = true;
          if(_.has(value,'type') && _self.checkProperty(value, 'type') == 'Letter' && _.has(value,'generated') &&
          (_self.checkProperty(value, 'generated') == true || _self.checkProperty(value, 'generated') == 'true') && !value['parentId'] 
            ){
            //&& !value['parentId'] removed parentId in above condition as per requirement
            this.showCloseIcon = true; 
            // && this.checkProperty( this.$store.state ,'selectedForEditDocument') && this.checkProperty( this.$store.state ,'selectedForEditDocument', 'savedDocumentId')
          } 
        }
        var _ob = {};
        if (value.editedDocument) {
          _ob = {
            // entityId:entityId,
           // petitionId: this.petition._id,
           petitionId:this.checkProperty(this.petition, '_id'),
            name: value.name,
            _id: value._id,
            extn: "docx",
            formLetterType: "Letter",
            parentId: value.parentId,
          };
        } else {
          _ob = {
            // entityId:entityId,
            name: value.name,
          //  petitionId: this.petition._id,
              petitionId:this.checkProperty(this.petition, '_id'),
            _id: value._id,
            extn: "docx",
            formLetterType: "Letter",
            parentId: value._id,
          };
        }
        var nid = value._id +  Math.round(+new Date()/1000)
        window.docEditor = new DocsAPI.DocEditor("placeholder2", {
          document: {
            c: "forcesave",
            fileType: "docx",
            key: nid,
            userdata: JSON.stringify(_ob),
            title: value.name,
            url: response.data.result.data,
            permissions: {
              edit: _editing,
              download: true,
              reader: false,
              review: false,
              comment: false,
            },
          },

          documentType: "word",
          height: "100%",
          width: "100%",

          editorConfig: {
            userdata: JSON.stringify(_ob),
            callbackUrl:
            docViewUrl+"?entityId="+entityId+"&payload=" +
              JSON.stringify(_ob) +
              "&token=" +
              _self.$store.state.token +
              "&name=" +
              value.name.replace(".docx", ""),
            customization: {
              logo: {
                image: "https://immibox.com/app/favicon.png",
                imageDark: "https://immibox.com/app/favicon.png",
                url: "https://immibox.com",
              },
              anonymous: {
                request: false,
                label: "Guest",
              },
              chat: false,
              comments: false,
              compactHeader: false,
              compactToolbar: true,
              compatibleFeatures: false,
              feedback: {
                visible: false,
              },
              forcesave: true,
              help: false,
              hideNotes: true,
              hideRightMenu: true,
              hideRulers: true,
              layout: {
                toolbar: {
                  collaboration: false,
                },
              },
              macros: false,
              macrosMode: "warn",
              mentionShare: false,
              plugins: false,
              spellcheck: false,
              toolbarHideFileName: true,
              toolbarNoTabs: true,
              uiTheme: "theme-light",
              unit: "cm",
              zoom: 100,
            },
          },
          events: {
            onReady: function () {},
            onDocumentStateChange: function (event) {
              var url = event.data;
              if (!event.data) {
                if (value.editedDocument) {
                }
              }
            },
          },
        });
      }

      if (this.docType == "pdf") {
        var formAndLetterId = value._id;
        let parentId = '';
        var  viewmode = 0;
        let pdfViewUrl ='https://immibox.com/viewer/pdfjs-dist/web/viewerv2.html';
        
        if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
          pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
        }
        if(_.has(value ,'viewmode')){
          if (value.viewmode) {
            viewmode = 0;
          }else{
            viewmode = 1;
            viewmode=viewmode+"&depLabel="+value.depLabel+"&depType="+value.depType+"&docUserType="+value.docUserType+"&generated="+value.generated+"&parentId="+parentId+"&formAndLetterId="+formAndLetterId+"&save=v2&docname="+value.name+"&posturl="+this.$globalgonfig._APIURL+"/&petitionId="+this.$route.params.itemId+"&entityId="+value.entityId+"&token="+this.$store.state.token
            if(_.has(this.$globalgonfig, 'PDF_EDIT_URL')){
              pdfViewUrl = this.$globalgonfig['PDF_EDIT_URL'];
              
              }
          }

        }
        if(this.getPetitionTab != 'Forms and Letters'){
          viewmode= 0; //Disabled Edit
          if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
            pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
          }
          
        }
        
        this.docValue =
        pdfViewUrl+"?view=" +
          viewmode +
          "+&file=" +
          encodeURIComponent(response.data.result.data);
      }
      this.docPrivew = true;
      });
      } else {
      this.downloads3file(value);
      }
    },
    },
    watch: {
     
    },
    mounted() {
      
    },
    data: () => ({
    saveEditedFile:false,
    formSubmited:false,
    expandModal: false,
    docPrivew: false,
    showCloseIcon:false,
    showConfrmLetterPopup:false,
    docValue: "",
    docType: "",
    selectedFile: null,
    }),
    props: {
      caseDetails: {
        type: Object,
        default: null,
      },
    },
  };
  </script>